import React, {useCallback} from 'react';

import {ChatModes} from '@buncha/batchDetails/types/Chat';
import ChatOpener from '@buncha/components/composites/ChatOpener';
import {HBox} from '../../../components/core/view';
import If from '@buncha/components/conditional/If';
import PdfIcon from '../../../components/core/icon/PdfIcon';
import ReceiptIcon from '../../../components/core/icon/ReceiptIcon';
import {ShopperScreens} from '../../../home/navigation/types';
import {Touchable} from '../../../components/core/touchable';
import {UserTypes} from '@buncha/onBoarding/types';
import {navigation} from '../../../config/navigation';
import {styles} from './styles';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useIsFocused} from '@react-navigation/native';

interface HeaderRightSectionProps {
  navigateToReceiptScreen: () => void;
  runId: number;
  isMeijerStore?: boolean;
}

function HeaderRightSection(props: HeaderRightSectionProps) {
  const {navigateToReceiptScreen, runId, isMeijerStore} = props;
  const theme = useColorThemeType();
  const isFocus = useIsFocused();

  const navigateToPdfDetailScreen = useCallback(() => {
    navigation.navigate(ShopperScreens.PdfDetailScreen, {runId: runId});
  }, [runId]);

  return (
    <HBox style={[styles.headerIconContainer]}>
      <If condition={!isMeijerStore && runId}>
        <Touchable onPress={navigateToReceiptScreen}>
          <ReceiptIcon
            fill={theme?.background.gray[100]}
            viewBox="-4 -10 25 25"
          />
        </Touchable>
      </If>
      <If condition={!isMeijerStore && runId}>
        <Touchable onPress={navigateToPdfDetailScreen}>
          <PdfIcon
            fill={theme?.background.gray[100]}
            viewBox="0 -5 25 25"
            style={[styles.rightIcon]}
          />
        </Touchable>
      </If>
      <If condition={!isMeijerStore && runId}>
        <ChatOpener
          hideRole={UserTypes.driver}
          mode={ChatModes.run}
          runId={isFocus ? runId : undefined}
          style={styles.chatIcon}
        />
      </If>
    </HBox>
  );
}

export default React.memo(HeaderRightSection);
